import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { encodeExportDetails } from '../utils/decode.util';
import { ChatAgentConfig } from '../hooks/use-url-config';
import { useEffect, useState } from 'react';

export const NewDemo = () => {
  const [companyName, setCompanyName] = useState('');
  const [agentId, setAgentId] = useState('');
  const [firstMessage, setFirstMessage] = useState('');
  const [generatedUrl, setGeneratedUrl] = useState('');
  const [copied, setCopied] = useState(false);

  const generateUrl = () => {
    if (!agentId || !companyName || !firstMessage) {
      return;
    }

    const config: ChatAgentConfig = {
      agent_id: agentId,
      company_name: companyName,
      first_message: firstMessage,
    };

    const encoded = encodeExportDetails(config);
    const baseUrl = window.location.origin;
    const url = `${baseUrl}/${encoded}`;
    setGeneratedUrl(url);
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(generatedUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  useEffect(() => {
    setCopied(false);
  }, [generatedUrl]);

  return (
    <Box width={1000} margin="auto" p={4}>
      <Typography variant="h4" gutterBottom>
        Generate Demo Chat URL
      </Typography>
      <Stack spacing={3} width={800}>
        <TextField
          label="Company Name"
          variant="standard"
          sx={{ width: 400 }}
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
        />
        <TextField
          label="Agent ID"
          variant="standard"
          sx={{ width: 400 }}
          value={agentId}
          onChange={(e) => setAgentId(e.target.value)}
          required
        />
        <TextField
          label="First Message"
          variant="standard"
          multiline
          value={firstMessage}
          onChange={(e) => setFirstMessage(e.target.value)}
          sx={{ width: 800 }}
        />

        <Button variant="contained" color="primary" onClick={generateUrl} sx={{ width: 200 }}>
          Generate URL
        </Button>

        {generatedUrl && (
          <Box mt={2}>
            <Typography variant="subtitle1" gutterBottom>
              Generated URL:
            </Typography>
            <TextField
              value={generatedUrl}
              fullWidth
              multiline
              variant="outlined"
              sx={{ pr: 1 }}
              disabled
            />
            <Button
              onClick={copyToClipboard}
              variant="outlined"
              color={copied ? 'success' : 'primary'}
              sx={{ mt: 1 }}
            >
              {copied ? 'Copied!' : 'Copy to clipboard'}
            </Button>
          </Box>
        )}
      </Stack>
    </Box>
  );
};
